import zipObject from 'lodash/zipObject';
import { getPendoColorNamesMap } from '@/constants/color-strings.js';

// Slot order is stored as `.groupColorNN` identity and must remain stable.
export const colorClasses = [
    '.groupColor01',
    '.groupColor02',
    '.groupColor03',
    '.groupColor04',
    '.groupColor05',
    '.groupColor06',
    '.groupColor07',
    '.groupColor08',
    '.groupColor09',
    '.groupColor10',
    '.groupColor11',
    '.groupColor12',
    '.groupColor13',
    '.groupColor14',
    '.groupColor15',
    '.groupColor16',
    '.groupColorUngrouped', // The "ungrouped" class must always be last
];

export const colors = [
    'var(--product-area-group-color-1)',
    'var(--product-area-group-color-2)',
    'var(--product-area-group-color-3)',
    'var(--product-area-group-color-4)',
    'var(--product-area-group-color-5)',
    'var(--product-area-group-color-6)',
    'var(--product-area-group-color-7)',
    'var(--product-area-group-color-8)',
    'var(--product-area-group-color-9)',
    'var(--product-area-group-color-10)',
    'var(--product-area-group-color-11)',
    'var(--product-area-group-color-12)',
    'var(--product-area-group-color-13)',
    'var(--product-area-group-color-14)',
    'var(--product-area-group-color-15)',
    'var(--product-area-group-color-16)',
    'var(--product-area-group-color-ungrouped)', // The "ungrouped" color must always be last
];

/* eslint-disable internal-rules/no-hardcoded-colors -- color name keys, not CSS colors */
const colorNameByClass = {
    '.groupColor01': ['regular', 'pink'],
    '.groupColor02': ['regular', 'magenta'],
    '.groupColor03': ['regular', 'orange'],
    '.groupColor04': ['regular', 'yellowOrange'],
    '.groupColor05': ['regular', 'teal'],
    '.groupColor06': ['regular', 'green'],
    '.groupColor07': ['regular', 'indigo'],
    '.groupColor08': ['light', 'indigo'],
    '.groupColor09': ['regular', 'purple'],
    '.groupColor10': ['light', 'purple'],
    '.groupColor11': ['light', 'green'],
    '.groupColor12': ['light', 'teal'],
    '.groupColor13': ['regular', 'red'],
    '.groupColor14': ['light', 'blue'],
    '.groupColor15': ['dark', 'blue'],
    '.groupColor16': ['regular', 'yellow'],
};
/* eslint-enable internal-rules/no-hardcoded-colors */

export const getColorLevel = (colorClass) => colorNameByClass[colorClass]?.[0];

export const colorMap = zipObject(colorClasses, colors);

export const colorClassMap = zipObject(colors, colorClasses);

// Row-major order for an 8-column by 2-row picker.
const pickerColorClasses = [
    '.groupColor01',
    '.groupColor03',
    '.groupColor16',
    '.groupColor11',
    '.groupColor12',
    '.groupColor14',
    '.groupColor08',
    '.groupColor10',
    '.groupColor02',
    '.groupColor13',
    '.groupColor04',
    '.groupColor06',
    '.groupColor05',
    '.groupColor15',
    '.groupColor07',
    '.groupColor09',
];

export const pickerColors = pickerColorClasses.map((className) => colorMap[className]);

export const getColorLabelsMap = () => {
    const colorNames = getPendoColorNamesMap();

    return colorClasses.slice(0, -1).reduce((labels, className) => {
        const [level, name] = colorNameByClass[className];
        labels[colorMap[className]] = colorNames[level][name];

        return labels;
    }, {});
};

export const defaultColorClass = colorClasses[0];

export const defaultColor = colorMap[defaultColorClass];
